import { useState } from 'react';
import { Switch } from '@headlessui/react';

function DTCWebsites() {
  const [platforms, setPlatforms] = useState({
    shopify: false,
    woocommerce: false,
    magento: false,
    bigcommerce: false
  });

  const [selectedPlatform, setSelectedPlatform] = useState(null);

  const platformConfigs = {
    shopify: {
      fields: ['Shop URL', 'API Key', 'API Secret', 'Access Token'],
      description: 'Connect your Shopify store to sync products, inventory, and orders automatically.'
    },
    woocommerce: {
      fields: ['Store URL', 'Consumer Key', 'Consumer Secret'],
      description: 'Integrate your WooCommerce store for seamless product and order management.'
    },
    magento: {
      fields: ['Store URL', 'Access Token'],
      description: 'Connect your Magento store to manage your products across all channels.'
    },
    bigcommerce: {
      fields: ['Store URL', 'API Key', 'Client ID', 'Client Secret'],
      description: 'Integrate your BigCommerce store for unified inventory management.'
    }
  };

  return (
    <div>
      <h1 className="text-4xl font-bold mb-8">DTC Websites</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {Object.entries({
          'Shopify': 'shopify',
          'WooCommerce': 'woocommerce',
          'Magento': 'magento',
          'BigCommerce': 'bigcommerce'
        }).map(([label, key]) => (
          <div
            key={key}
            className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-xl font-semibold">{label}</h3>
                <p className="text-gray-500 text-sm mt-1">
                  {platforms[key] ? 'Connected' : 'Not Connected'}
                </p>
              </div>
              <Switch
                checked={platforms[key]}
                onChange={(checked) => {
                  setPlatforms((prev) => ({ ...prev, [key]: checked }));
                  if (checked) {
                    setSelectedPlatform(key);
                  }
                }}
                className={`${
                  platforms[key] ? 'bg-indigo-600' : 'bg-gray-200'
                } relative inline-flex h-6 w-11 items-center rounded-full`}
              >
                <span className="sr-only">Enable {label}</span>
                <span
                  className={`${
                    platforms[key] ? 'translate-x-6' : 'translate-x-1'
                  } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                />
              </Switch>
            </div>
            <p className="text-gray-600 text-sm">
              {platformConfigs[key].description}
            </p>
            {platforms[key] && (
              <button
                onClick={() => setSelectedPlatform(key)}
                className="mt-4 text-indigo-600 text-sm hover:text-indigo-700"
              >
                Configure Settings →
              </button>
            )}
          </div>
        ))}
      </div>

      {selectedPlatform && (
        <div className="bg-white rounded-xl p-6 shadow-sm">
          <h2 className="text-2xl font-bold mb-6">
            Configure {selectedPlatform.charAt(0).toUpperCase() + selectedPlatform.slice(1)}
          </h2>
          <div className="space-y-4">
            {platformConfigs[selectedPlatform].fields.map((field) => (
              <div key={field}>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {field}
                </label>
                <input
                  type={field.toLowerCase().includes('secret') || field.toLowerCase().includes('key') ? 'password' : 'text'}
                  className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  placeholder={`Enter ${field.toLowerCase()}`}
                />
              </div>
            ))}
            <div className="flex justify-end space-x-4 mt-6">
              <button
                onClick={() => setSelectedPlatform(null)}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700"
              >
                Save Configuration
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DTCWebsites;